import React, { useState } from 'react'
import { formatCompactNumber } from '../../../utils'

// Custom Linear Progress Component
const CustomLinearProgress = ({
  label,
  value,
  max,
  onClick,
  onHover,
  onExit,
  color,
}) => {
  const [showTooltip, setShowTooltip] = useState(false)

  const progress = max > 0 ? (value / max) * 100 : 0
  let delta = 0
  if (value > max) {
    delta = progress - 100
  }

  const handleMouseEnter = () => {
    setShowTooltip(true)
    onHover && onHover()
  }

  const handleMouseLeave = () => {
    setShowTooltip(false)
    onExit && onExit()
  }

  return (
    <div className='income-data-sidebar__linear-progress'>
      {/* Tooltip */}
      {showTooltip && (
        <div className='income-data-sidebar__linear-progress-tooltip'>
          {formatCompactNumber(value, { maximumFractionDigits: 0, minimumFractionDigits: 0 })}
          <div className='income-data-sidebar__linear-progress-tooltip-arrow' />
        </div>
      )}

      <div className='income-data-sidebar__linear-progress-container'>
        {label
          ? (
            <div className='income-data-sidebar__linear-progress-label'>
              {label}
            </div>
            )
          : null}

        {/* Main Progress Bar */}
        <div
          onClick={onClick}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          className={`income-data-sidebar__linear-progress-bar ${onClick ? '' : 'income-data-sidebar__linear-progress-bar--default'}`}
        >
          <div
            className='income-data-sidebar__linear-progress-fill'
            style={{
              width: `${Math.min(progress - delta, 100)}%`,
              backgroundColor: color,
            }}
          />
        </div>

        <div className={`income-data-sidebar__linear-progress-max ${progress > 100 ? 'income-data-sidebar__linear-progress-max--overflow' : ''}`}>
          {formatCompactNumber(max, { maximumFractionDigits: 0, minimumFractionDigits: 0 })}
        </div>

        {/* Overflow Progress Bar */}
        {progress > 100 && (
          <div
            onClick={onClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            className={`income-data-sidebar__linear-progress-overflow ${onClick ? '' : 'income-data-sidebar__linear-progress-overflow--default'}`}
          >
            <div
              className='income-data-sidebar__linear-progress-fill'
              style={{
                width: '100%',
                backgroundColor: color,
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default CustomLinearProgress
